import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import LegacyNotificationDetail from '../components/LegacyNotificationDetail';
import BreadCrumb from '../../shared/components/BreadCrumb';
import { Typography } from '@material-ui/core';

export interface INotificationRouteParams {
  notificationId: string;
}

const LegacyOrganizationNotificationDetail = (
  props: RouteComponentProps<INotificationRouteParams>
) => {
  return (
    <div>
      <Typography
        color="textSecondary"
        gutterBottom={true}
        className="padding-bottom-8"
      >
        <BreadCrumb value="Organization" to="/organization/settings" />
        <BreadCrumb value="Notifications" to="/organization/notifications" />
        {props.match.params.notificationId && 'Edit'}
        {!props.match.params.notificationId && 'New'}
      </Typography>
      <LegacyNotificationDetail />
    </div>
  );
};

export default withRouter(LegacyOrganizationNotificationDetail);



// WEBPACK FOOTER //
// ./src/modules/organization/pages/LegacyOrganizationNotificationDetail.tsx